export enum ScoreTypes {
	GRADIENT_CIRCLE = 'gradient-circle',
	SCORE_BAR = 'score-bar',
	NUMBER_ONLY = 'number-only',
}
